
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.089 0A2.087 2.087 0 000 2.086v27.826a2.087 2.087 0 002.089 2.089h27.826a2.084 2.084 0 002.086-2.089V2.086c0-.553-.218-1.085-.609-1.477S30.469 0 29.915 0zm0 1.279h27.826a.807.807 0 01.807.807v27.826a.807.807 0 01-.807.807h-3.872a10.07 10.07 0 00-1.063-3.984 10.102 10.102 0 00-3.026-3.568 2.138 2.138 0 00-2.252-.216c-1.144.583-2.409.885-3.693.885s-2.549-.302-3.693-.885a2.166 2.166 0 00-2.24.216 10.152 10.152 0 00-3.031 3.607 10.129 10.129 0 00-1.044 3.945H2.09a.807.807 0 01-.807-.807V2.086a.807.807 0 01.807-.807zm13.562 5.935a7.216 7.216 0 00-4.737 2.099 7.195 7.195 0 00-1.56 7.838A7.202 7.202 0 0016 21.594h.003a7.205 7.205 0 006.646-4.442 7.185 7.185 0 00-.667-6.748 7.19 7.19 0 00-6.331-3.19zM16 8.497h.003c1.565.003 3.064.626 4.172 1.732s1.735 2.604 1.74 4.169c.003 1.17-.341 2.315-.99 3.289s-1.571 1.735-2.651 2.185-2.269.568-3.417.341a5.91 5.91 0 01-4.653-4.644 5.919 5.919 0 012.51-6.075A5.914 5.914 0 0116 8.497zm-4.74 15.508a.866.866 0 01.466.07 9.426 9.426 0 008.562 0 .887.887 0 01.909.115 8.804 8.804 0 013.57 6.529H7.257a8.808 8.808 0 013.573-6.529.84.84 0 01.43-.185z"}})])
          )
        }
      }
    